import { render, staticRenderFns } from "./bidStep.vue?vue&type=template&id=0f39d1b3&scoped=true"
import script from "./bidStep.vue?vue&type=script&lang=js"
export * from "./bidStep.vue?vue&type=script&lang=js"
import style0 from "./bidStep.vue?vue&type=style&index=0&id=0f39d1b3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f39d1b3",
  null
  
)

export default component.exports